import { Calendar, CalendarClock, CalendarDays, type LucideIcon, Repeat, Zap } from 'lucide-react';

import {
  createDefaultRecurrenceRule,
  type PrimaryRecurrenceType,
  type RecurrenceRule,
} from '@irl/validation';

import { DEFAULT_TIMEZONE } from '@/lib/timezone-options';

export interface QuickCreateConfig {
  sendMode?: 'now' | 'schedule';
  recurrenceType?: PrimaryRecurrenceType;
}

export interface QuickCreatePreset {
  id: string;
  labelKey: string;
  icon: LucideIcon;
  config: QuickCreateConfig;
}

export function buildQuickRecurrenceRule(type: PrimaryRecurrenceType): RecurrenceRule {
  switch (type) {
    case 'once':
      return createDefaultRecurrenceRule({ type: 'once', timezone: DEFAULT_TIMEZONE });
    case 'daily':
      return createDefaultRecurrenceRule({ type: 'daily', timezone: DEFAULT_TIMEZONE });
    case 'weekly':
      return createDefaultRecurrenceRule({
        type: 'weekly',
        timezone: DEFAULT_TIMEZONE,
        weekdays: [1, 2, 3, 4, 5],
      });
    case 'monthly':
      return createDefaultRecurrenceRule({ type: 'monthly', timezone: DEFAULT_TIMEZONE });
    default:
      return createDefaultRecurrenceRule({ type, timezone: DEFAULT_TIMEZONE });
  }
}

export const QUICK_CREATE_PRESETS: QuickCreatePreset[] = [
  {
    id: 'now',
    labelKey: 'quickCreate.now',
    icon: Zap,
    config: { sendMode: 'now' },
  },
  {
    id: 'once',
    labelKey: 'recurrence.types.once',
    icon: CalendarClock,
    config: { recurrenceType: 'once' },
  },
  {
    id: 'daily',
    labelKey: 'recurrence.types.daily',
    icon: Repeat,
    config: { recurrenceType: 'daily' },
  },
  {
    id: 'weekly',
    labelKey: 'quickCreate.weekdays',
    icon: CalendarDays,
    config: { recurrenceType: 'weekly' },
  },
  {
    id: 'monthly',
    labelKey: 'recurrence.types.monthly',
    icon: Calendar,
    config: { recurrenceType: 'monthly' },
  },
];
